// extracted by mini-css-extract-plugin
export var downArrow = "_ba-0";
export var label = "_ba-1";
export var treatmentCard = "_ba-3";
export var upArrow = "_ba-2";